import L from 'leaflet';
export default class OpenStreetMap {
    constructor(containerId, posts) {
        this.map = null;
        this.markers = [];
        this.posts = [];
        this.markerButtonTitle = null;
        this.container = document.getElementById(containerId);
        if (!this.container)
            return;
        this.markerButtonTitle = this.container.dataset.viewMore;
        this.posts = posts;
        this.initMap(containerId);
    }
    initMap(containerId) {
        if (this.posts.length === 0) {
            console.warn('No posts with coordinates found');
            return;
        }
        const center = this.calculateCenter();
        this.map = L.map(containerId, {
            center: [center.lat, center.lng],
            zoom: 13,
            zoomControl: false
        });
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        this.addMarkers();
        // fix for rendering issues
        setTimeout(() => {
            var _a;
            (_a = this.map) === null || _a === void 0 ? void 0 : _a.invalidateSize();
        }, 0);
    }
    calculateCenter() {
        if (this.posts.length === 1) {
            return this.posts[0].coordinates;
        }
        const lat = this.posts.reduce((sum, post) => sum + post.coordinates.lat, 0) / this.posts.length;
        const lng = this.posts.reduce((sum, post) => sum + post.coordinates.lng, 0) / this.posts.length;
        return { lat, lng };
    }
    createNumberIcon(number) {
        return L.divIcon({
            html: `<div class="map-pin-marker">${number}</div>`,
            className: 'number-marker',
            iconSize: [30, 30],
            iconAnchor: [15, 30],
        });
    }
    addMarkers() {
        this.posts.forEach((post, index) => {
            const number = index + 1;
            const icon = this.createNumberIcon(number);
            const link = post.link ? post.link : false;
            const marker = L.marker([post.coordinates.lat, post.coordinates.lng], { icon })
                .addTo(this.map)
                .bindPopup(`
          <div class="map-popup">
            <h2 class="heading-quaternary">${post.title}</h2>
            ${this.markerButtonTitle && link ? `<a href="${post.link}" class="btn-primary">${this.markerButtonTitle}</a>` : ``}
          </div>
        `);
            // open first popup
            // if (index === 0) {
            //     marker.openPopup();
            // }
            this.markers.push(marker);
        });
    }
    destroy() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
        this.markers = [];
    }
}
